import { useDispatch, useSelector } from "react-redux"
import { RootState } from "~/redux/store"
import { SettingsEntity } from "@jackfruit/common"
import { useMemo } from "react"
import { settings as settingsState } from "~/redux/state/settings"

export const useSettings = () => {
  const dispatch = useDispatch()
  const settings = useSelector<RootState, SettingsEntity>(
    state => state.settings.data
  )

  const settingsActions = useMemo(() => {
    return {
      updateRecaptchaToken: (recaptchaToken: string | null) => {
        const token = recaptchaToken || undefined
        dispatch(settingsState.actions.updateRecaptchaToken(token))
      },
    }
  }, [dispatch])

  return { settings, settingsActions }
}
